// Applicant-portal specific: Stripe key mapping by region and gateway
import {
  STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY,
} from "../../../constants";

// Re-export from shared @certn/utils package for fonts and options
export { fonts, options } from "@certn/utils";

// Map region codes (from auth0_primary_region) to Stripe publishable keys
export const mapRegionToStripeKey: Record<string, string> = {
  CA: STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  US: STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  UK: STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  AU: STRIPE_INTERCHECK_PUBLISHABLE_KEY,
};

// Map StripeGateway values (from backend) to publishable keys
// This mapping handles all gateways including prepay accounts
export const mapGatewayToStripeKey: Record<string, string> = {
  STRIPE_CERTN_CANADA: STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  STRIPE_CERTN_CANADA_PREPAY: STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA: STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PREPAY: STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK: STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PREPAY: STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK: STRIPE_INTERCHECK_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PREPAY: STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_CONSUMER: STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY,
};
